import React, { useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import Modal from "../../../Pages/ModalForm";
import "./GovMidBanner.css";
import Heading from "../../../utls/Heading";
const GovMidBanner = () => {
  const [showModal, setShowModal] = useState(false);

  const handleShow = (e) => {
    e.preventDefault(); // Prevent default behavior of anchor tag or button
    setShowModal(true); // Show the modal
  };

  const handleClose = () => setShowModal(false); // Close the modal

  return (
    <>
      <div className="container sports-mid-section">
        <div className="row px-md-4">
          <div className="col-md-12">
            <Heading className="customheadings">
              <span>Your Gateway</span> to Professional Global Engagements
            </Heading>
            <p className="grotesk-headings sports-mid-banner-p">
              We strive to provide government travelers with exceptional
              services. We are committed to providing our clients with the best
              possible government travel services. We know that adapting our
              services to each client's needs is an important part of our
              understanding of the uniqueness of every trip.
            </p>
          </div>
        </div>
      </div>

      <div className="gov-last-banner ">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 text-white">
              <Heading className="customheadings">
                <span className="last-banner-span">Dedicating</span> Our Efforts
                to Your Travel Well-Being
              </Heading>
              <div className="carouselCaption">
                <button
                  className="btn bg-transparent text-white mt-md-3 grotesk-headings fw-bold"
                  type="button" // Ensure it's type="button" to prevent form submission
                  onClick={handleShow}
                >
                  Request Demo
                </button>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="gov-banner-img bt-last-banner">
                <LazyLoadImage
                  src="https://blueberrywebsites.azureedge.net/bbt/images/govmidbanner.png"
                  alt="Travel Banner"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Conditionally render the Modal outside the button */}
      <Modal show={showModal} handleClose={handleClose} />
    </>
  );
};

export default GovMidBanner;
